export default {
    employees: [],
    employee: null,
};
